import { useMemo, useRef } from "react";
import Instrument from "shared/games/instruments/Instrument";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import { useRefMeasure } from "util/useMeasure";

interface Params {
  instruments: Instrument[];
  instrument: MixPuzzleInstrument;
}

export default function useSelectedMixPanelPosition({
  instrument,
  instruments,
}: Params) {
  const selectedIndex = instruments.indexOf(instrument.instrument);
  const consoleRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const channelStripRefs = useRef<(HTMLElement | null)[]>([]);
  const {
    width: widthToForceRerenderIfItChangesDueToResizeEvenThoughItIsntUsedInHook,
  } = useRefMeasure({ ref: consoleRef });
  const consoleStyle = useMemo(() => {
    const channelEl = channelStripRefs.current[selectedIndex];
    const isLast =
      instruments.length > 3 && selectedIndex === instruments.length - 1;

    if (!channelEl || !containerRef.current) {
      return { top: 0 };
    }

    if (isLast) {
      return { top: "auto", bottom: 0 };
    }

    const { top: containerTop } = containerRef.current.getBoundingClientRect();
    const { top: selectedChannelTop } = channelEl.getBoundingClientRect();

    let top = selectedChannelTop - containerTop;

    return {
      top,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    instruments.length,
    selectedIndex,
    widthToForceRerenderIfItChangesDueToResizeEvenThoughItIsntUsedInHook,
  ]);

  return {
    consoleRef,
    containerRef,
    channelStripRefs,
    consoleStyle,
  };
}
